import template from 'url-template';

import { get  } from 'lodash';

import {
    FETCH_CLIENT_CONTACTS,
    FETCH_SITE_CONTACTS,
    SET_SELECTED_CONTACT
} from './actionTypes';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { setBobLoading } from './bobActions';
import { enqueueSnackbar, handleNetworkError } from './applicationMessageActions';

const ContactsUrl = template.parse('/usertypes{?ClientId,UserType,SiteId,Email,includeClientSites}');
const DeleteContactUrl = template.parse('/usertypes/{userTypeUserId}');
const UpdateContactUrl = template.parse('/usertypeusers/contact/{userTypeUserId}');
const UserTypesUrl = template.parse('/users/{userId}/usertypes{?UserType,ClientId,SiteId}');
const CreateContactUrl = template.parse('/companies/{companyId}/usertypeusers/contact');
const FetchTitlesUrl = template.parse('/companies/{companyId}/lookups{?type}');
const PhoneUrl = template.parse('/phones');

export const createClientContact = (companyId, body) => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading('CreateContact'));

    try {
        await k2aBaseApi.post(
            CreateContactUrl.expand({
                companyId
            }),
            body,
            header
        );

        dispatch(enqueueSnackbar('Contact created successfully.', 'success'));
        dispatch(setBobLoading('CreateContact'));
        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        dispatch(setBobLoading('CreateContact'));
        return false;
    }
};

export const createContactPhoneNumber = body => async (dispatch, getState) => {
    const header = await awsHeader();

    dispatch(setBobLoading('CreatePhoneNumber'));

    try {
        const response = await k2aBaseApi.post(
            PhoneUrl.expand({}),
            body,
            header
        );

        const payload = get(response, 'data', {});

        dispatch(enqueueSnackbar('Phone number created successfully.', 'success'));
        return payload;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    } finally {
        dispatch(setBobLoading('CreatePhoneNumber'));
    }
};

export const fetchContactTitles = companyId => async (dispatch, getState) => {
    const header = await awsHeader();
    const type = 'ContactTitle';

    dispatch(setBobLoading('FetchTitles'));

    try {
        const response = await k2aBaseApi.get(
            FetchTitlesUrl.expand({
                companyId,
                type
            }),
            header
        );

        const payload = get(response, 'data.data', []);
        dispatch(setBobLoading('FetchTitles'));
        return payload;
    } catch (error) {
        dispatch(setBobLoading('FetchTitles'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchContactsById = (clientId, userId) => async (dispatch, getState) => {
    const header = await awsHeader();

    dispatch(setBobLoading('FetchSiteContacts'));

    const ClientId = clientId;
    const UserType = 'Contact';

    try {
        const response = await k2aBaseApi.get(
            UserTypesUrl.expand({
                userId,
                UserType,
                ClientId
            }),
            header
        );

        const payload = get(response, 'data', []);
        dispatch(setBobLoading('FetchSiteContacts'));

        return payload;

    } catch (error) {
        dispatch(setBobLoading('FetchSiteContacts'));
        dispatch(handleNetworkError(error));
        return false;
    }

};

export const fetchClientContacts = (clientId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading('FetchClientContacts'));

    const ClientId = clientId;
    const UserType = 'Contact';

    try {
        const response = await k2aBaseApi.get(
            ContactsUrl.expand({
                ClientId,
                UserType,
                ...options
            }),
            header
        );

        const payload = get(response, 'data', []);

        payload.forEach(item => {
            const primary = item.userAssignmentPhones.find(item => item.isPrimary === true);
            const sms = item.userAssignmentPhones.find(item => item.isSMS === true);
            item.userName.fullName = `${item.userName.FirstName} ${item.userName.LastName}`;
            if (sms) item.smsNumber = sms.phoneNumber.number;
            if (primary) item.primaryNumber = primary.phoneNumber.number;
        });

        const meta = { isCompleted: true };

        dispatch({
            type:    FETCH_CLIENT_CONTACTS,
            payload: {
                data: payload,
                meta
            }
        });
        dispatch(setBobLoading('FetchClientContacts'));
    } catch (error) {
        dispatch(setBobLoading('FetchClientContacts'));
        dispatch(handleNetworkError(error));
    }
};

export const confirmClientContactEmail = (clientId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading('FetchClientContacts'));

    const ClientId = clientId;
    const UserType = 'Contact';

    try {
        const response = await k2aBaseApi.get(
            ContactsUrl.expand({
                ClientId,
                UserType,
                ...options
            }),
            header
        );

        const payload = get(response, 'data', []);
        dispatch(setBobLoading('FetchClientContacts'));

        return payload;
    } catch (error) {
        dispatch(setBobLoading('FetchClientContacts'));
        dispatch(handleNetworkError(error));
        return false;
    }
};

export const fetchSiteContacts = (clientId, siteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading('FetchSiteContacts'));

    const ClientId = clientId;
    const SiteId = siteId;
    const UserType = 'Contact';

    try {
        const response = await k2aBaseApi.get(
            ContactsUrl.expand({
                ClientId,
                SiteId,
                UserType,
                ...options
            }),
            header
        );

        const payload = get(response, 'data', []);

        payload.forEach(item => {
            const primary = item.userAssignmentPhones.find(item => item.isPrimary === true);
            const sms = item.userAssignmentPhones.find(item => item.isSMS === true);
            item.userName.fullName = `${item.userName.FirstName} ${item.userName.LastName}`;
            if (sms) item.smsNumber = sms.phoneNumber.number;
            if (primary) item.primaryNumber = primary.phoneNumber.number;
        });

        const meta = { isCompleted: true };

        dispatch({
            type:    FETCH_SITE_CONTACTS,
            payload: {
                data: payload,
                meta
            }
        });
        dispatch(setBobLoading('FetchSiteContacts'));
    } catch (error) {
        dispatch(handleNetworkError(error));
        dispatch(setBobLoading('FetchSiteContacts'));
    }
};

export const confirmSiteContactEmail = (clientId, siteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    dispatch(setBobLoading('FetchSiteContacts'));

    const ClientId = clientId;
    const SiteId = siteId;
    const UserType = 'Contact';

    try {
        const response = await k2aBaseApi.get(
            ContactsUrl.expand({
                ClientId,
                SiteId,
                UserType,
                ...options
            }),
            header
        );

        const payload = get(response, 'data', []);

        dispatch(setBobLoading('FetchSiteContacts'));

        return payload;
    } catch (error) {
        dispatch(handleNetworkError(error));
        dispatch(setBobLoading('FetchSiteContacts'));
        return false;
    }
};

export const deleteContact = userTypeUserId => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading('DeleteContact'));

    try {
        await k2aBaseApi.delete(
            DeleteContactUrl.expand({
                userTypeUserId
            }),
            header
        );
        dispatch(setBobLoading('DeleteContact'));
        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        dispatch(setBobLoading('DeleteContact'));
        return false;
    }
};

export const bulkDeleteContact = userTypeUserIds => async (dispatch, getState) => {
    const header = await awsHeader();

    dispatch(setBobLoading('DeleteContact'));

    try {
        let promises = [];

        userTypeUserIds.forEach(item => {
            promises.push(k2aBaseApi.delete(DeleteContactUrl.expand({userTypeUserId: item}), header));
        });

        await Promise.all(promises.map(p => p.catch(err => err)));

        dispatch(setBobLoading('DeleteContact'));
        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        dispatch(setBobLoading('DeleteContact'));
        return false;
    }
};

export const setClientContacts = (contacts, meta) => async (dispatch, getState) => {
    dispatch({
        type:    FETCH_CLIENT_CONTACTS,
        payload: {
            data: contacts,
            meta
        }
    });
};

export const setSiteContacts = (contacts, meta) => async (dispatch, getState) => {
    dispatch({
        type:    FETCH_SITE_CONTACTS,
        payload: {
            data: contacts,
            meta
        }
    });
};

export const setSelectedContact = contact => async (dispatch, getState) => {
    dispatch({
        type:    SET_SELECTED_CONTACT,
        payload: contact
    });
};

export const updateContact = (userTypeUserId, body) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await k2aBaseApi.put(
            UpdateContactUrl.expand({
                userTypeUserId
            }),
            body,
            header
        );

        dispatch(enqueueSnackbar('Contact updated successfully.', 'success'));
        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
};
